import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiForgotPassword } from '../../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resetLink, setResetLink] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');
    setResetLink('');

    const data = await apiForgotPassword(email);
    if (data.error) {
      setError(data.error);
      return;
    }

    setMessage(data.message || 'Se existir conta com este email, você receberá instruções.');
    if (data.resetLink) {
      setResetLink(data.resetLink);
    }
  };

  // Redireciona automaticamente quando a API retornar o resetLink.
  useEffect(() => {
    if (!resetLink) return;

    // Pequeno delay para o usuário ver a mensagem antes do redirecionamento.
    const t = setTimeout(() => {
      try {
        window.location.assign(resetLink);
      } catch (e) {
        // fallback: atualizar a janela
        window.location.href = resetLink;
      }
    }, 1200);

    return () => clearTimeout(t);
  }, [resetLink]);

  return (
    <div className="page-container">
      <div className="card">
        <h1 className="card-title">Recuperar senha</h1>
        <form onSubmit={handleSubmit}>
          {error && <p className="api-error">{error}</p>}
          {message && <p className="api-success">{message}</p>}

          <div className="form-group">
            <label htmlFor="recover-email">Email</label>
            <input
              id="recover-email"
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="seu@email.com"
            />
          </div>

          <button className="submit-btn" type="submit">Gerar link</button>
        </form>

        {/* Link retornado pela API é usado apenas para redirecionamento automático; não exibimos ao usuário. */}

        <p className="toggle-text">
          Lembrou a senha? <Link to="/login" className="toggle-btn">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
}
